'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _selectionContext = require('../contexts/selection-context');

var _selectionContext2 = _interopRequireDefault(_selectionContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (Component) {
  return function () {
    return _react2.default.createElement(_selectionContext2.default.Consumer, null, function (selectRow) {
      return _react2.default.createElement(Component, selectRow);
    });
  };
};